import MyService from '../../service';

function makeFormData(param) {
  const formData = new FormData();

  Object.keys(param).forEach((item) => {
    formData.append(item, param[item]);
  });

  return formData;
}
const TestimonialApi = {
  index: async () => {
    try {
      const { data } = await MyService.getRequestData('/testimonial');

      return data || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  },
  show: async (id) => {
    try {
      const { data } = await MyService.getRequestData(`/testimonial/${id}`);

      return data || null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  create: async (param) => {
    try {
      const { data } = await MyService.postRequestData(
        `/testimonial`,
        makeFormData(param)
      );

      return data || null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  edit: async (id, param) => {
    try {
      const { data } = await MyService.putRequestData(
        `/testimonial/${id}`,
        makeFormData(param),
        {
          accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        }
      );

      return data || null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  publish: async (id) => {
    try {
      const { data } = await MyService.putRequestData(
        `/testimonial/change-status/${id}`,
        {
          status: 1,
        }
      );

      return data || null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  unPublish: async (id) => {
    try {
      const { data } = await MyService.putRequestData(
        `/testimonial/change-status/${id}`,
        {
          status: 0,
        }
      );

      return data || null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
};

export default TestimonialApi;
